import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer style={{
            backgroundColor: '#1f2937', // Dark gray/blue background
            color: '#d1d5db', // Light gray text
            padding: '20px 0',
            marginTop: 'auto', // Pushes footer to the bottom of the page
            textAlign: 'center',
            fontSize: '14px'
        }}>
            <div style={{ marginBottom: '10px' }}>
                <Link to="/guide" style={{ color: '#60a5fa', textDecoration: 'none', margin: '0 15px' }}>
                    User Guide
                </Link>
                |
                <Link to="/terms" style={{ color: '#60a5fa', textDecoration: 'none', margin: '0 15px' }}>
                    Terms of Use & Privacy
                </Link>
            </div>
            <p style={{ margin: 0 }}>
                &copy; {currentYear} Tournament Master. All rights reserved.
            </p>
        </footer>
    );
};

export default Footer;